import { Component, Injector, Input, OnInit, AfterViewInit } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss';

import { SitecoreComponent } from 'components/shared/sitecore';
import { PageName, PlanType } from 'core/constants';
import { Cloudinary } from 'services/cloudinary';

@Component({
    selector: 'marketing-plan-features',
    styleUrls: ['./plan-features.scss'],
    templateUrl: './plan-features.html'
})
export class MarketingPlanFeaturesComponent extends SitecoreComponent implements OnInit, AfterViewInit {
    @Input() public rendering: ComponentRendering;

    public pageData: PlanFeatures;
    public sectionIcon: MediaImageOptions;
    public icon: MediaImageOptions;
    public dollarSymbol: string;
    public rateplanPrice: string;
    public isPlanPage: boolean;
    public isOverViewPage: boolean;
    public planFeatureTwo: boolean;
    public planFeatureOne: boolean;
    public observer: MutationObserver | null = null;

    constructor(injector: Injector) {
        super(injector);
    }

    public ngOnInit(): void {
        this.pageData = this.flattenFields<PlanFeatures>(this.rendering.fields);

        this.dollarSymbol = this.pageData.ratePlanPrice?.charAt(0);
        this.rateplanPrice = this.pageData.ratePlanPrice?.slice(1);
        this.isPlanPage = this.pageData.pageName === PageName.PLAN;
        this.isOverViewPage = this.pageData.pageName === PageName.OVERVIEW;
        this.planFeatureTwo = this.pageData.featureClass === PlanType.UNLIMITED_PREMIUM;
        this.planFeatureOne = this.pageData.featureClass === PlanType.UNLIMITED_INTRO;

        if (this.pageData.sectionIcon) {
            this.sectionIcon = Cloudinary.generateMediaOptionsFromCms(this.pageData.sectionIcon);
        }
    }

    public ngAfterViewInit(): void {
        // Ensure height calculation after DOM and content are fully rendered
        setTimeout(() => {
            this.updateMaxHeight();
        }, 200);

        // Observe DOM changes for dynamic content
        this.observeDomChanges();

        // Recalculate height on window resize
        window.addEventListener('resize', () => this.updateMaxHeight());
    }

    private updateMaxHeight(): void {
        const elIntro = document.querySelector('.unl-intro') as HTMLElement | undefined;
        const elPremium = document.querySelector('.unl-premium-flex') as HTMLElement | undefined;

        if (elIntro && elPremium) {
            const introHeight = elIntro.scrollHeight;
            const premiumHeight = elPremium.scrollHeight;
            const maxHeight = Math.max(introHeight, premiumHeight);

            elIntro.style.setProperty('--max-feature-list-size', `${maxHeight}px`);
            elPremium.style.setProperty('--max-feature-list-size', `${maxHeight}px`);
        }
    }

    private observeDomChanges(): void {
        const observer = new MutationObserver(() => {
            this.updateMaxHeight();
        });

        const targetNode = document.body; // Adjust this to the parent container of the elements
        const config = { childList: true, subtree: true };

        observer.observe(targetNode, config);

        // Disconnect the observer when the component is destroyed
        this.observer = observer;
    }

    public ngOnDestroy(): void {
        this.observer?.disconnect();
    }

    public generateImageFromCms(image: CmsMediaOptionsImage): MediaImageOptions {
        return Cloudinary.generateMediaOptionsFromCms(image);
    }
}
